import React from 'react';
import styled from 'styled-components';
import {labels} from '../../../../../../../util/utils';

export default function ALRAAssertionsTableBottom() {
	return (
		<StyledALRAAsSertionsTableBottom className="StyledALRAAsSertionsTableBottom">
			<section className="RisksTypesContainer">
				<span className="risk high-risk">{labels.ALRAHigherRiskCode}</span>
				<span className="RiskLabel">{labels.ALRAHigherInherentRisk}</span>
			</section>
			<section className="RisksTypesContainer">
				<span className="risk low-risk">{labels.ALRALowerRiskCode}</span>
				<span className="RiskLabel">{labels.ALRALowerInherentRisk}</span>
			</section>
			<section className="RisksTypesContainer">
				<span className="risk related-to-assertion" />
				<span className="RiskLabel">{labels.ALRARiskRelatedToAssertion}</span>
			</section>
			<section className="RisksTypesContainer">
				<span className="risk contributes-to-higherInherentRisk" />
				<span className="RiskLabel">{labels.ALRAContributesToHigherInherentRisk}</span>
			</section>
		</StyledALRAAsSertionsTableBottom>
	);
}

const StyledALRAAsSertionsTableBottom = styled.section`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	padding: var(--px-12);
	border: var(--px-1) solid var(--neutrals-200);
	border-top: 0 !important;
	border-radius: 0 0 var(--px-8) var(--px-8);
	background-color: var(--neutrals-00white);
	.RisksTypesContainer {
		display: inline-flex;
		align-items: center;
		& + .RisksTypesContainer {
			margin-left: var(--px-12);
		}
		.related-to-assertion {
			height: var(--px-8);
			width: var(--px-8);
			background-color: var(--neutrals-300);
			border-radius: 50%;
			display: inline-block;
		}
		.contributes-to-higherInherentRisk {
			height: var(--px-13);
			width: var(--px-13);
			background-color: #b14891;
			border-radius: 50%;
			display: inline-block;
		}
	}
	.risk {
		background-color: #fff;
		color: #656579;
		border-radius: var(--px-4);
		font-size: var(--px-12);
		font-weight: 400;
		line-height: var(--px-20);
		display: inline-flex;
		justify-content: center;
		align-items: center;
		width: var(--px-20);
		height: var(--px-20);
		&.high-risk {
			border: var(--px-1) solid #b14891;
			background-color: #b14891;
			color: #fff;
			svg {
				color: #fff;
				cursor: auto;
			}
		}
		&.low-risk {
			border: var(--px-2) solid #b14891;
			background: var(--neutrals-00white);
			color: var(--neutrals-1000);
			svg {
				color: var(--neutrals-1000);
				cursor: auto;
			}
		}
	}
	.RiskLabel {
		font-size: var(--px-12);
		font-weight: 300;
		line-height: var(--px-16);
		color: #656579;
		margin-left: var(--px-8);
	}
`;
